import {ReactElement} from 'react';
import StyledActionText from './styles';
import Props from './typings';

const ActionText = ({fontSize = 16, disabled = false, onClick, children}: Props): ReactElement => {
  return (
    <StyledActionText
      role="button"
      $fontSize={fontSize}
      onClick={onClick}
      $disabled={disabled}
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault(); // Prevent scrolling on space
          if (onClick) onClick(e);
        }
      }}
    >
      {children}
    </StyledActionText>
  );
};

export default ActionText;
